/* eslint-disable */
import domReady from '@wordpress/dom-ready';

function initAlertComponent() {
  const alertBar = document.querySelector('.alert-bar');

  if (!alertBar) return;

  const closeButton = alertBar.querySelector('.alert-bar__close-btn');
  const alertHash = alertBar.dataset.alertHash;
  const cookieName = `alertBarClosed_${alertHash}`;

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  function showAlert() {
    alertBar.classList.add('alert-bar--is-open');
    document.body.classList.remove('alert-hidden');
    document.body.classList.add('alert-visible');
  }

  function closeAlert() {
    alertBar.classList.remove('alert-bar--is-open');
    document.body.classList.remove('alert-visible');
    alertBar.classList.add('alert-bar--is-closed');
    document.body.classList.add('alert-closed');
    setCookie(cookieName, 'true', 1); // Cookie expires in 1 day
  }

  // Check if alert has been closed before
  const alertClosed = getCookie(cookieName) === 'true';

  if (!alertClosed) {
    showAlert();
  } else {
    document.body.classList.add('alert-hidden');
  }

  closeButton?.addEventListener('click', () => {
    closeAlert();
  });
}

domReady(() => {
  initAlertComponent();
});
